export default {
    props: {
        messagesToolsMoveDown: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.moveDown'
        }, 
        messagesToolsMoveUp: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.moveUp'
        }, 
        messagesToolsRemove: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.remove'
        }, 
        messagesToolsTransferAllFrom: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferAllFrom'
        }, 
        messagesToolsTransferAllTo: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferAllTo'
        }, 
        messagesToolsTransferFrom: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferFrom'
        }, 
        messagesToolsTransferTo: {
            type: String,
            default: undefined,
            kComposite: 'messages.tools.transferTo'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-listbox-vue-wrapper/src/KendoListBox/Messages.js